// Action Types for Images
export const GET_IMAGES_REQUEST = "GET_IMAGES_REQUEST";
export const GET_IMAGES_SUCCESS = "GET_IMAGES_SUCCESS";
export const GET_IMAGES_FAILURE = "GET_IMAGES_FAILURE";
export const GET_TAGGED_MEDIA_SUCCESS = "GET_TAGGED_MEDIA_SUCCESS";
export const GET_PEXELS_IMAGES_REQUEST = "GET_PEXELS_IMAGES_REQUEST";
export const GET_PEXELS_IMAGES_SUCCESS = "GET_PEXELS_IMAGES_SUCCESS";
export const GET_PEXELS_IMAGES_FAILURE = "GET_PEXELS_IMAGES_FAILURE";
export const PUT_IMAGES_REQUEST = "PUT_IMAGES_REQUEST";
export const PUT_IMAGES_SUCCESS = "PUT_IMAGES_SUCCESS";
export const GET_PRESIGNED_URLS_REQUEST = "GET_PRESIGNED_URLS_REQUEST";
export const GET_PRESIGNED_PUT_URLS_REQUEST = "GET_PRESIGNED_PUT_URLS_REQUEST";
export const GET_PRESIGNED_URLS_SUCCESS = "GET_PRESIGNED_URLS_SUCCESS";
export const GET_TAGGED_MEDIA_REQUEST = "GET_TAGGED_MEDIA_REQUEST";

// Action Types for Tags
export const GET_TAGS_REQUEST = "GET_TAGS_REQUEST";
export const GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS";
export const GET_TAGS_FAILURE = "GET_TAGS_FAILURE";

// Action to request fetching images
export const getImages = (payload) => ({
  type: GET_IMAGES_REQUEST,
  payload,
});

export const getPexelsImages = (searchTerms) => {
  const actionPayload = {
    type: GET_PEXELS_IMAGES_REQUEST,
    payload: searchTerms,
  };
  console.log(
    `PMM - SF - mediaActions - getPexelsImages - actionPayload is: ${JSON.stringify(
      actionPayload
    )}`
  );
  return actionPayload;
};

// Action for successful image fetch
export const getImagesSuccess = (images) => ({
  type: GET_IMAGES_SUCCESS,
  payload: { images },
});

export const getPexelsImagesSuccess22 = (payload) => ({
  type: GET_PEXELS_IMAGES_SUCCESS,
  payload,
});

export const getPexelsImagesSuccess = (payload) => {
  const actionPayload = { type: GET_PEXELS_IMAGES_SUCCESS, payload };
  // console.log(
  //   `PMM - SF - actions - getPexelsImagesSuccess - actionPayload is: ${JSON.stringify(
  //     actionPayload
  //   )}`
  // );
  return actionPayload;
};

// Action for failed image fetch
export const getImagesFailure = (error) => ({
  type: GET_IMAGES_FAILURE,
  payload: { error },
});

export const getPexelsImagesFailure = (payload) => ({
  type: GET_PEXELS_IMAGES_FAILURE,
  payload,
});

export const getTags = (payload) => {
  return {
    type: GET_TAGS_REQUEST,
    payload,
  };
};

// Action for successful tag fetch
export const getTagsSuccess = (tags) => ({
  type: GET_TAGS_SUCCESS,
  payload: { tags },
});

// Action for failed tag fetch
export const getTagsFailure = (error) => ({
  type: GET_TAGS_FAILURE,
  payload: { error },
});

// Action Creator for successfully fetching images
export const getTaggedMediaSuccess = (images) => ({
  type: GET_TAGGED_MEDIA_SUCCESS,
  payload: images,
});

// Action Creator for putting images
export const putImagesRequest = (payload) => ({
  type: PUT_IMAGES_REQUEST,
  payload,
});

// Action Creator for successfully putting images
export const putImagesSuccess = (response) => ({
  type: PUT_IMAGES_SUCCESS,
  payload: response,
});

export const getPresignedUrlsRequest = (fileNames) => {
  // console.log(
  //   `PMM - SF - imageActions.js - getPresignedUrlsRequest initiated - fileNames is: ${JSON.stringify(
  //     fileNames
  //   )}`
  // );
  const actionPayload = {
    type: GET_PRESIGNED_URLS_REQUEST,
    payload: fileNames,
  };
  return actionPayload;
};

export const getPresignedPutUrlsRequest = (fileNames) => {
  console.log(
    `PMM - SF - imageActions.js - getPresignedPutUrlsRequest initiated - fileNames is: ${JSON.stringify(
      fileNames
    )}`
  );
  const actionPayload = {
    type: GET_PRESIGNED_PUT_URLS_REQUEST,
    payload: fileNames,
  };
  return actionPayload;
};

export const getTaggedMedia = (tagSet) => {
  // console.log(
  //   `PMM - SF - imageActions.js - getTaggedMedia initiated - fileNames is: ${JSON.stringify(
  //     tagSet
  //   )}`
  // );
  const actionPayload = {
    type: GET_TAGGED_MEDIA_REQUEST,
    payload: tagSet,
  };
  return actionPayload;
};

// Action Creator for successfully getting pre-signed URLs
export const getPresignedUrlsSuccess = (presignedUrls) => {
  // console.log(
  //   `PMM - SF - imageActions.js - getPresignedUrlsSuccess - presignedUrls is: ${JSON.stringify(
  //     presignedUrls
  //   )}`
  // );
  const actionPayload = {
    type: GET_PRESIGNED_URLS_SUCCESS,
    payload: presignedUrls,
  };
  return actionPayload;
};
